<template>
    <div>

        <!-- Top box -->

        <trax-ui-top-box :id="id" :endpoint="endpoint+'/'+phase.id" :endpoint-params="endpointParams" 
            :custom-class="customClass" :props="props" :map="map" :bus="bus"
            :title2="registration.program.name" description-toggle="1" description-hidden="1"
            :button-icon="buttonIcon" :button-name="buttonName" :button-handler="buttonHandler" :button-href="buttonHref" 
            :link1="group" :link2="location"
            :user-name="userName" :user-picture="userPicture">
        </trax-ui-top-box>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id" :bus="bus">
            <enac-atpl-dashboard-phase-edit-form :bus="bus" :id="id" :endpoint="endpoint" :registration-id="registration.id">
            </enac-atpl-dashboard-phase-edit-form>
        </trax-ui-modal-default>

    </div>
</template>

<script>
    export default {

        props: {
            id: {default: 'enac-atpl-dashboard-phase-custom-top-box'},
            groupLink: { default: false },
            customizeButton: null,
            topButtons: null,
            displayLearner: null
        },

        data() {
            return {
                lang: lang,
                user: user,
                app_url: app_url,
                registration: data.registration,
                phase: data.phase,
                learner: data.learner,
                aggregation_dashboard_routes: data.aggregation_dashboard_routes,
                endpoint: app_url+'polaris/api/front/phases',
                endpointParams: {
                    relations: ['location'],
                    options: { registration: data.registration.id }
                },
                props: {
                    name: { source:'name' },
                    description: {source: 'description'},
                    custom: {source: 'custom'},
                    location: {source: 'location'},
                    background: {source: 'meta.background'}
                },
                map: {
                    title1: 'name',
                    descriptionTitle: this.hdvRef,
                    description: 'description',
                    backgroundImage: 'background'
                },
                bus: new Vue()
            }
        },

        computed: {

            customClass() {
                return this.topButtons ? 'mb-1' : '';
            },

            userName() {
                if (!this.displayLearner || !this.learner) return null;
                return this.learner.lastname + ' ' + this.learner.firstname;
            },

            userPicture() {
                if (!this.displayLearner || !this.learner) return null;
                return this.learner.avatar;
            },

            buttonIcon() {
                if (this.customizeButton && this.customAggregationPermission) {
                    return 'location_on';
                }
                if (this.learner) {
                    return 'playlist_add_check';
                }
                return null;
            },

            buttonName() {
                if (this.customizeButton && this.customAggregationPermission) {
                    return this.lang.polaris.dashboard.customize;
                }
                if (this.learner) {
                    return this.lang.polaris.dashboard.skills_progress;
                }
                return null;
            },

            buttonHref() {
                if (this.customizeButton && this.customAggregationPermission) {
                    return null
                }
                if (this.learner) {
                    return this.app_url + 'polaris/ui/atpl-dashboard/registration/' + this.registration.id
                        + '/enac-atpl-phase/' + this.phase.id
                        + '/learner/' + this.learner.id
                        + '/skills-progress';
                }
                return null
            },

            group() {
                var link = {value: this.registration.cohort.name, icon: 'people'};
                var routes = this.aggregation_dashboard_routes;
                var href = routes[this.phase.type]+'/registration/'+this.registration.id+'/'+this.phase.type+'/'+this.phase.id;
                if (this.collectiveDashboardPermission && this.groupLink) link.href = href;
                return link;
            },

            collectiveDashboardPermission() {
                return this.user.admin || this.user.permissions['dashboard.read-all'] || this.user.permissions['dashboard.read-mine-locations']
                    || this.user.permissions['dashboard.read-mine-collaborators'] || this.user.permissions['dashboard.write-all']
                    || this.user.permissions['dashboard.write-mine-locations'] || this.user.permissions['registration.manage'];
            },

            customAggregationPermission() {
                return this.user.admin || this.user.permissions['dashboard.customize-phases'];
            }
        },

        methods: {

            hdvRef(data) {
                if (!data.custom || !data.custom.meta.hdv_ref) return null;
                return 'HDV: ' + data.custom.meta.hdv_ref;
            },

            location(data) {
                if (data.custom && data.custom.location) {
                    return {value: data.custom.location.name, icon: 'location_on'};
                }
                if (data.location) {
                    return {value: data.location.name, icon: 'location_on'};
                }
                return null
            },

            buttonHandler(data) {
                if (this.customizeButton && this.customAggregationPermission) {
                    this.bus.$emit(this.id+'-update', data);
                }
                return null
            },
        }
    }
</script>
